import React from 'react';
import styles from './Section2.module.scss';

const Section2 = () => {
  return (
    <div className={`${styles.container}`}>
      <div className={`${styles.contentContainer}`}>
        <div className={`${styles.heading}`}>Rewards ✨</div>
        <img
          className={`${styles.rewardsIllustration}`}
          src={'https://asset.arredigital.co/Arr%C3%A9+Voice+Fest/images/section/rewardsIllustration.png'}
          alt="Rewards Illustration"
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default Section2;
